var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Section',{attrs:{"width":"md"}},[(_vm.$validateText(_vm.headerText))?_c('div',{staticClass:"rich-text header",domProps:{"innerHTML":_vm._s(_vm.$prismic.asHtml(_vm.headerText))}}):_vm._e(),_vm._v(" "),_c('Table',{attrs:{"table-headers":_vm.tableHeaders,"table-values":_vm.tableValues}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }